var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ayuda-tema-base',{attrs:{"busqueda":_vm.busqueda,"color":_vm.color,"faqs":_vm.faqs,"video-url":"https://share.synthesia.io/embeds/videos/cc2a2038-a3f9-45d6-8f5c-c86703a71c50","video-titulo":"Expedientes"}})
}
var staticRenderFns = []

export { render, staticRenderFns }